import React, { MouseEventHandler, useState } from "react";
import { Icon } from "@cadmakers-ui/icons";
import styles from "../../../Styles/ChildFeedbackDisplayList.module.scss";
import { RelationshipDisplayFeedback } from "../../../Models/Feedback";

export type Props = {
  childItemsList?: RelationshipDisplayFeedback[];
  onDeleteChild?: (childItemsList?: RelationshipDisplayFeedback[]) => void;
  onRelationshipDeselect: (value: number, label: string) => void;
};

export const ChildFeedbackDisplayList = (props: Props) => {
  const { childItemsList, onDeleteChild } = props;

  // Remove child item from display list
  const onClick = (event: any) => {
    event.stopPropagation();
    const newList = childItemsList?.filter(child => {
      props.onRelationshipDeselect(
        event.target.getAttribute("id"),
        event.target.parentNode.getAttribute("id")
      );
      return child.value.toString() !== event.target.getAttribute("id");
    });
    if (onDeleteChild) {
      onDeleteChild(newList);
    }
  };

  // Generate the bullet points for each child item
  const makeList = childItemsList?.map(child => {
    return (
      <li key={child.value} className={styles.list} onClick={onClick}>
        <div style={{ maxWidth: "320px", width: "320px" }}>{child.label}</div>
        <div id={child.label}>
          <Icon
            id={child.value.toString()}
            className={styles.icon}
            appName="GeneralLayout"
            assetName="GENERAL_F_Clear"
            onClick={onClick}
          />
        </div>
      </li>
    );
  });

  if (!childItemsList || childItemsList.length <= 0) {
    return <></>;
  }

  return (
    <div style={{ textAlign: "left" }}>
      <div style={{ fontWeight: "bold" }}>Child items list</div>
      <ul style={{ padding: 0 }}>{makeList}</ul>
    </div>
  );
};
